export * from "./allBlocks.pure";

import { RegisterAllNodeRenderGraphBlocks } from "./allBlocks.pure";
RegisterAllNodeRenderGraphBlocks();
